import { useCookies } from 'react-cookie'
import { getCookie } from "src/helpers/queryHelpers"

export default function useDeviceId() {
  const [cookies] = useCookies()

  async function getDeviceId() {
    try {
      if (typeof window === 'undefined') return null
      const dId = getCookie("deviceId") || cookies.deviceId
      if (dId) return dId.trim()
      // If deviceId is not found in cookies, fetch it from the API
      const res = await fetch('/api/auth/device')
      if (!res.ok) throw new Error(`Failed to fetch device ID: ${res.statusText}`)
      const resJson = await res.json()
      if (!resJson || typeof resJson !== 'object') throw new Error('Invalid response format')
      if (typeof resJson.device !== 'string' || resJson?.device?.trim() === '') throw new Error('Device ID is not a valid string')
      return resJson.device.trim()
    } catch (error) {
      console.error('Error in getDeviceId:', error)
      return null
    }
  }

  return {
    getDeviceId
  }
}
